
export const getConfigs = (): IConfigs => {
    let env: any = process.env.NODE_ENV || 'development';
    if(process.env.REACT_APP_ENV){
        env='staging'
    }
    let envConfigs = require('./' + env)
    return envConfigs.config
}